import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epmsa320TimesList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa320/epmsa320TimesList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa320(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa320/epmsa320`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa320Xls(param) {
  const data = param
  return request({
    url: `/outsoucingBlockControl/epmsa320/epmsa320Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epmsa320XlsRes', res)

    const filename = 'Steel Cutting Closing(Invoice).xls'
    xlsDownload(filename, res)
  })
}

export function epmsa320Change(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa320/epmsa320Change`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa320Cancel(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa320/epmsa320Cancel`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

